import { APP_SETTING_TOGGLE_CSS_EDITOR_MODAL } from './constants';

export function toggleCssEditorModal() {
  return {
    type: APP_SETTING_TOGGLE_CSS_EDITOR_MODAL,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_TOGGLE_CSS_EDITOR_MODAL:
      return {
        ...state,
        isOpenCssEditorModal: !state.isOpenCssEditorModal,
      };

    default:
      return state;
  }
}
